import { getIconKey } from './oaIcons'
import { FLOW_TYPES } from './oaBusiness'
// One catalogue owns the launch/list routes; adding a workflow never adds a sidebar item.
export const APPLICATIONS = [
  ...Object.keys(FLOW_TYPES).filter(type=>FLOW_TYPES[type].launch!==false).map(type=>({key:FLOW_TYPES[type].target,name:FLOW_TYPES[type].name,beta:FLOW_TYPES[type].beta,category:FLOW_TYPES[type].category,description:'按业务填写并提交审批',icon:'el-icon-document-checked',tone:FLOW_TYPES[type].tone||'teal',permission:null,create:'/oa/business/'+type+'/edit',list:'/oa/business/'+type,keywords:FLOW_TYPES[type].name+(type==='SHIPMENT'?' 普通合同发货 合同待确认发货 售后发货 待确定合同发货通知单 售后服务发货通知单':'')})),
  {key:'purchaseApply',name:'采购申请',category:'合同与采购',description:'快捷发起采购申请',icon:'el-icon-shopping-cart-2',tone:'orange',permission:'crm:procurement:save',create:'/procurement/apply/new',list:'/procurement/apply'},
  {key:'contract',name:'合同申请',category:'合同与采购',description:'快捷发起合同申请',icon:'el-icon-document',tone:'blue',permission:'crm:contract:manage',create:'/crm/contract/manage',query:{create:'1'},list:'/crm/contract/manage'},
  { key: 'purchaseContractApproval', name: '采购合同审批', category: '合同与采购', description: '采购合同审批及实际盖章办理', icon: 'el-icon-document-checked', tone: 'orange', permission: null, create: '/procurement/contracts/edit', list: '/procurement/contracts', keywords: '采购 合同 用印 盖章' },
  { key: 'expenseClaim', name: '费用报销', category: '费用与资金', description: '差旅、接待与日常费用报销', icon: 'el-icon-tickets', tone: 'blue', permission: 'crm:expense:apply', create: '/finance/expense/edit', list: '/oa/expense-claims', keywords: '报销 费用 差旅 接待 交通' },
  { key: 'executiveExpenseClaim', name: '总经理董事长报销', category: '费用与资金', description: '管理层简化报销，抄送成本会计', icon: 'el-icon-tickets', tone: 'blue', permission: 'crm:expense:apply', create: '/finance/expense/edit', query: { claimType: 'EXECUTIVE' }, list: '/oa/expense-claims', keywords: '报销 费用 差旅 接待 交通' },
  { key: 'paymentApplication', name: '付款申请', category: '费用与资金', description: '合同款项与采购费用付款', icon: 'el-icon-bank-card', tone: 'green', permission: 'crm:finance:apply', create: '/finance/applications/PAYMENT/edit', list: '/finance/applications/PAYMENT', keywords: '支付 合同 采购 付款' },
  { key: 'loanApplication', name: '借款申请', category: '费用与资金', description: '项目与业务临时借款', icon: 'el-icon-wallet', tone: 'orange', permission: 'crm:finance:apply', create: '/finance/applications/LOAN/edit', list: '/finance/applications/LOAN', keywords: '借款 备用金 临时' },
  { key: 'invoiceApplication', name: '开票申请', category: '费用与资金', description: '提交开票信息，跟进发票办理', icon: 'el-icon-document-checked', tone: 'purple', permission: 'crm:finance:apply', create: '/finance/applications/INVOICE/edit', list: '/finance/applications/INVOICE', keywords: '发票 开票 合同' }
].sort((a,b)=>Number(Boolean(a.beta))-Number(Boolean(b.beta))).map(item=>({...item,iconKey:getIconKey(item.key,null,item.name)}))

export const VIEWS = [
  { key: 'pending', label: '待我处理', empty: '当前没有待处理的申请', hint: '新的审批或办理任务会出现在这里' },
  { key: 'mine', label: '我发起的', empty: '还没有发起过审批', hint: '点击右上角“发起申请”选择需要办理的业务' },
  { key: 'handled', label: '我已处理', empty: '暂无已处理的申请', hint: '您审批或办理过的申请会保留在这里' },
  { key: 'cc', label: '抄送我的', empty: '暂无抄送给您的申请', hint: '流程抄送记录会出现在这里' }
]

export function allowed(permissions, permission) {
  if (permission == null) return true
  if (Array.isArray(permission)) return permission.some(p => allowed(permissions, p))
  return (permissions || []).some(p => p === '*:*:*' || p === permission)
}
export function applicationMeta(type,code,name) {
  const item=APPLICATIONS.find(x=>x.key===type)||{name:'业务审批',tone:approvalTypeTone(code)}
  return {...item,iconKey:getIconKey(type,code,name)}
}
// Stable, named colours for every approval type, including future categories.
export function approvalTypeTone(type) {
  const tones = { 1: 'indigo', 2: 'rose', 3: 'terracotta', 4: 'amber', 5: 'cyan', 6: 'violet', 7: 'magenta', 8: 'teal', 9: 'azure', 10: 'indigo', 11: 'green', 12: 'amber', 13: 'rose', 14: 'blue', 15: 'green', 16: 'orange', 17: 'purple' }
  if (tones[type]) return tones[type]
  const palette = ['indigo', 'teal', 'amber', 'cyan', 'violet', 'rose', 'azure', 'magenta']
  const hash = Array.from(String(type == null ? 'other' : type)).reduce((value, char) => (value * 31 + char.charCodeAt(0)) >>> 0, 0)
  return palette[hash % palette.length]
}
export function approvalProgress(row) {
  const status = Number(row.workOrderStatus)
  // A submitted instance owns its outcome, even after the application is resubmitted.
  if (status === 4) return '已撤回'
  if (status === 3) return '已驳回'
  if (status === 5) return '线下已结束'
  if (row.targetType === 'purchaseContractApproval') {
    if (status === 2) return '已用印办结'
    if (status === 1 && row.stage === 'handling') return (row.currentApproverNames || '') + '待用印办理'
  }
  if (status === 1 && Number(row.financeStatus) === 30) return '已付款，待补发票'
  if (status === 1 && Number(row.financeStatus) === 40) return '待总账确认发票'
  if (status === 1) return (row.currentApproverNames || '') + (row.stage === 'handling' ? '办理中' : '审批中')
  if (status === 2) {
    if (row.currentApplication !== 0 && row.currentApplication !== false) {
      if (row.noPaymentRequired === true || Number(row.noPaymentRequired) === 1) return '无需付款'; if (row.expenseStatus != null) return ({30:'待付款',40:'部分付款',50:'已结清'})[Number(row.expenseStatus)] || '已通过'
      if (Number(row.financeStatus) === 50) return '已办结'
    }
    return '已通过'
  }
  return row.workOrderStatusDesc || '—'
}
export function isHistoricalApplication(row) {
  return ['expenseClaim','paymentApplication','loanApplication','invoiceApplication'].includes(row.targetType) && Number(row.currentApplication) === 0
}
export function preferenceKey(user, suffix) {
  return `oa:${user.tenantId}:${user.userId}:${suffix}`
}
export function readPreference(key, fallback) {
  try { const value = JSON.parse(localStorage.getItem(key)); return value == null ? fallback : value } catch (_) { return fallback }
}
export function writePreference(key, value) {
  try { localStorage.setItem(key, JSON.stringify(value)); return true } catch (_) { return false }
}
export function safeReturn(route, fallback = '/oa/approval') {
  const path = route.query && route.query.returnTo
  if (typeof path === 'string' && /^\/oa\/applications(\?|$)/.test(path)) return '/oa/approval?view=mine'
  return typeof path === 'string' && /^\/(oa\/(approval|ledger|applications|expense-claims)|finance\/applications\/(PAYMENT|LOAN|INVOICE))(\?|$)/.test(path) ? path : fallback
}

// Normalize only an existing, authorized OA menu. The former application center
// remains a hidden redirect so bookmarks never expose a second OA page.
export function normalizeOaMenus(routes) {
  return routes.map(route => {
    const children = route.children || []
    const isOa = ['oa', '/oa'].includes(route.path) && children.some(c => c.component === 'oa/index')
    if (!isOa) return { ...route, ...(children.length ? { children: normalizeOaMenus(children) } : {}) }
    const normalized = children.map(c => {
      const applicationCenter = c.component === 'oa/applications' || c.name === 'OaApplicationCenter'
      return {
        ...c,
        hidden: applicationCenter ? true : c.hidden,
        ...(applicationCenter ? { component: 'oa/index', redirect: '/oa/approval?view=mine' } : {}),
        meta: { ...c.meta, noCache: true }
      }
    })
    if (!normalized.some(c => c.name === 'OaApplicationCenter' || c.path === 'applications')) normalized.push({ path: 'applications', component: 'oa/index', redirect: '/oa/approval?view=mine', hidden: true, name: 'OaApplicationCenter', meta: { title: '审批中心', noCache: true } })
    return { ...route, alwaysShow: true, children: normalized }
  })
}
